import styled from "styled-components";

export const StyledContentNumberChip = styled.div`
  width: 30px;
  padding: 2px 5px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
